// A cookie-session API answers an anonymous request with a 302 to Microsoft. Following it cross-origin fails on
// CORS, so stop at the redirect: the response comes back opaque (status 0) and reads as signed out.
export function probeSession(url: string): Promise<Response> {
    return fetch(url, { credentials: "include", redirect: "manual" });
}
